/*
 * @Author: Yue Hu(yuhu@nvidia.com)
 * @Date: 2024-11-16 11:33:19
 * @LastEditors: Yue Hu(yuhu@nvidia.com)
 * @LastEditTime: 2024-11-20 00:01:46
 * @FilePath: /mooctest.com/src/api/paper.js
 */
// 任务相关api
import request from "../utils/request";

// 获取试卷的题目列表
export function caseOfPaperGet(paperId, examId) {
  return request({
    url: `/cases/${paperId}/${examId}`,
    method: "GET",
  });
}

// 获取所有试题列表
export function caseListGet(keyword, activePage) {
  return request({
    url: "/case",
    method: "GET",
    params: {
      keyword,
      activePage,
    },
  });
}

// 获取所有试卷列表
export function paperListGet(keyword, activePage) {
  return request({
    url: "/papers",
    method: "GET",
    params: {
      keyword,
      activePage,
    },
  });
}
// 获取试卷信息
export function paperInfoGet(paperId, examId) {
  return request({
    url: `/paper/${paperId}`,
    method: "GET",
    params: {
      examId,
    },
  });
}
